import { RouteRecordRaw } from 'vue-router';

const inboxRoutes: Array<RouteRecordRaw> = [
  {
    path: 'inbox',
    component: () => import('@/app/inbox/components/inbox-component.vue'),
    name: 'app.inbox',
  },
];

export default inboxRoutes;
